export const GTM_EVENTS = {
  lead: 'gtm.lead',
  sale: 'gtm.sale',
};

export const GA_EVENTS = {
  addToCart: 'add_to_cart',
  removeFromCart: 'remove_from_cart',
  viewCart: 'view_cart',
  beginCheckout: 'begin_checkout',
  addPaymentInfo: 'add_payment_info',
};

export const GA_ECOMMERCE_FIELDS = {
  cardType: 'cardType',
  transactionId: 'transaction_id',
  value: 'value',
  currency: 'currency',
  coupon: 'coupon',
  id: 'item_id',
  name: 'item_name',
  category: 'item_category',
  price: 'price',
  quantity: 'quantity',
};

export const GTM_ENHANCED_CONVERSION_FIELDS = {
  customerPhone: 'customerPhone',
  customerEmail: 'customerEmail',
  customerCity: 'customerCity',
  customerCountry: 'customerCountry',
  customerStreet: 'customerStreet',
  customerState: 'customerState',
  customerFirstName: 'customerFirstName',
  customerLastName: 'customerLastName',
  customerZip: 'customerZip',
};
